<section class="">
    <div *ngIf="!showCreateUser">
      <ng-container *ngIf="filteredSchoolUsers.length == 0 && !showSchoolUser; else schoolUserList">
        <div *ngIf="schoolData.length" class="table-responsive tab-table school-detail-table px-3 mb-0">
          <table
          aria-describedby="This table describes the mat admin information"
          class="table table-hover"
          >
          <thead>
            <tr>
              <th>S.No</th>
              <th>School Name
                <mat-icon *ngIf="sortSchoolNameAsc" (click)="
                                    sortSchoolNameAsc = false;
                                    getGridData('schoolName', 'asc')
                                  ">arrow_upward
                </mat-icon>
                <mat-icon *ngIf="!sortSchoolNameAsc" (click)="
                                  sortSchoolNameAsc = true;
                                    getGridData('schoolName', 'desc')
                                  ">arrow_downward
                </mat-icon>
              </th>
              <th>School Code</th>
              <th *ngIf="userRole.includes(roleMaster.SuperAdmin) || userRole.includes(roleMaster.AccountAdmin)">School Reference</th>
              <th *ngIf="clientAccountId == 0">Account Admin
                <mat-icon *ngIf="sortAssignedAccountAdminAsc" (click)="
                                    sortAssignedAccountAdminAsc = false;
                                    getGridData('assignedAccountAdmin', 'asc')
                                  ">arrow_upward
                </mat-icon>
                <mat-icon *ngIf="!sortAssignedAccountAdminAsc" (click)="
                                  sortAssignedAccountAdminAsc = true;
                                    getGridData('assignedAccountAdmin', 'desc')
                                  ">arrow_downward
                </mat-icon>
              </th>
              <th>Location
                <mat-icon *ngIf="sortLocationAsc" (click)="
                                    sortLocationAsc = false;
                                    getGridData('location', 'asc')
                                  ">arrow_upward
                </mat-icon>
                <mat-icon *ngIf="!sortLocationAsc" (click)="
                                  sortLocationAsc = true;
                                    getGridData('location', 'desc')
                                  ">arrow_downward
                </mat-icon>
              </th>
              <th>School Capacity</th>
              <th>Headcount</th>
              <th>No of School Users</th>
              <th>Teaching Staff</th>
              <th>Non-Teaching Staff</th>
              <th>School Type
                <mat-icon *ngIf="sortSchoolTypeAsc" (click)="
                                 sortSchoolTypeAsc = false;
                                    getGridData('schoolType', 'asc')
                                  ">arrow_upward
                </mat-icon>
                <mat-icon *ngIf="!sortSchoolTypeAsc" (click)="
                                  sortSchoolTypeAsc = true;
                                    getGridData('schoolType', 'desc')
                                  ">arrow_downward
                </mat-icon>
              </th>
              <th>Curriculum
                <mat-icon *ngIf="sortCurriculumAsc" (click)="
                                    sortCurriculumAsc = false;
                                    getGridData('curriculum', 'asc')
                                  ">arrow_upward
                </mat-icon>
                <mat-icon *ngIf="!sortCurriculumAsc" (click)="
                                  sortCurriculumAsc = true;
                                    getGridData('curriculum', 'desc')
                                  ">arrow_downward
                </mat-icon>
              </th>
              <th>Address
                <mat-icon *ngIf="sortAddressAsc" (click)="
                                sortAddressAsc = false;
                                getGridData('address', 'asc')
                              ">arrow_upward
                </mat-icon>
                <mat-icon *ngIf="!sortAddressAsc" (click)="
                                  sortAddressAsc = true;
                                    getGridData('address', 'desc')
                                  ">arrow_downward
                </mat-icon>
              </th>
              <th>Local Authority
                <mat-icon *ngIf="sortLocalAuthorityAsc" (click)="
                                 sortLocalAuthorityAsc = false;
                                getGridData('localAuthority', 'asc')
                              ">arrow_upward
                </mat-icon>
                <mat-icon *ngIf="!sortLocalAuthorityAsc" (click)="
                                  sortLocalAuthorityAsc = true;
                                    getGridData('localAuthority', 'desc')
                                  ">arrow_downward
                </mat-icon>
              </th>
              <th>ID: URN/DfE Number/UKPRN</th>
              <th class="action-header">Comment</th>
              <th class="action-header">Document</th>
              <th class="action-header sticky-right">Action</th>

            </tr>
          </thead>
          <tbody class="tbody-userlists">
            <tr *ngFor="let school of schoolData; index as i" (click)="goToSchoolUsers(school)" class="cursor-pointer">
              <td>{{i + 1}}</td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.schoolName!">
                  <a class="text-decoration-underline text-grey-e" (click)="goToSchoolUsers(school)"> {{school.schoolName}}</a>
                </p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.id">{{school.id}}</p>
              </td>
              <td *ngIf="userRole.includes(roleMaster.SuperAdmin) || userRole.includes(roleMaster.AccountAdmin)">
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.myReferenceSchoolCode!">{{school.myReferenceSchoolCode}}</p>
              </td>
              <td *ngIf="clientAccountId == 0" (click)=" $event.preventDefault();$event.stopPropagation();">
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.assignedAccountAdminName!">
                  <a *ngIf="school.assignedAccountAdmin!=null" href="mailto:{{school.assignedAccountAdminEmail}}">{{school.assignedAccountAdminName}}</a></p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.location!">{{school.location}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.schoolCapacity}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.headcountOfSchool}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.numberOfSchoolUser}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.numberOfNonTeachingStaff}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.numberOfTeachingStaff}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.schoolType!">{{school.schoolType}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.curriculum!">{{school.curriculum}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.address!">{{school.address}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-clientname mb-0" [matTooltip]="school.localAuthority!">{{school.localAuthority}}</p>
              </td>
              <td>
                <p class="mat-account-detail user-detail-empid mb-0">{{school.schoolRegistrationId}}</p>
              </td>
              <td>
                <span class="cursor-pointer">
                  <svg
                  (click)="$event.preventDefault();$event.stopPropagation();openCommentModal(school.notes!)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
                      stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path opacity="0.4"
                      d="M22.0003 12.8603C22.0003 15.1503 20.8203 17.1803 19.0003 18.4603L17.6603 21.4103C17.3503 22.0803 16.4503 22.2103 15.9803 21.6403L14.5003 19.8603C12.0803 19.8603 9.92031 18.7903 8.57031 17.1203L9.50031 16.0003C13.6403 16.0003 17.0003 12.8703 17.0003 9.00031C17.0003 7.95031 16.7503 6.96031 16.3003 6.07031C19.5703 6.82031 22.0003 9.58029 22.0003 12.8603Z"
                      stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </td>
              <td class="text-center">
                <a class="cursor-pointer">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  ViewDocument(school)">
                    <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#4F6681"
                      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M7 13H13" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 17H11" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </td>


                 
              <td class="sticky-right" 
              [style.zIndex]="schoolData.length - i" 
              (click)="$event.preventDefault();$event.stopPropagation();">
                <ng-container>

                   <div class="d-flex align-items-start">
                    
                  <a *ngIf="openedFromIndependentSchool" class="btn-action view-my-insights" (click)="$event.preventDefault();$event.stopPropagation();goToMyInsights(school)" matTooltip="View My Insights">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21 16.25H15C14.59 16.25 14.25 15.91 14.25 15.5C14.25 15.09 14.59 14.75 15 14.75H21C21.41 14.75 21.75 15.09 21.75 15.5C21.75 15.91 21.41 16.25 21 16.25Z"
                        fill="#5D847B" fill-opacity="0.8" />
                      <path
                        d="M21 20.25H15C14.59 20.25 14.25 19.91 14.25 19.5C14.25 19.09 14.59 18.75 15 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z"
                        fill="#5D847B" fill-opacity="0.8" />
                      <path opacity="0.4"
                        d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
                        fill="#5D847B" fill-opacity="0.8" />
                      <path
                        d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
                        fill="#5D847B" fill-opacity="0.8" />
                      <path opacity="0.4"
                        d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
                        fill="#5D847B" fill-opacity="0.8" />
                    </svg>
                  </a>
                  
                      <div class="dropdown dropdown-actions">
                      
                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                          aria-expanded="false">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                              stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                              stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                              stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a class="dropdown-item"  matTooltipPosition="left" matTooltip="Edit details" (click)="$event.preventDefault();
                                $event.stopPropagation();editSchool(school)" matTooltip="Edit details">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.84 2.4008L3.36667 8.19413C3.16 8.41413 2.96 8.84746 2.92 9.14746L2.67334 11.3075C2.58667 12.0875 3.14667 12.6208 3.92 12.4875L6.06667 12.1208C6.36667 12.0675 6.78667 11.8475 6.99334 11.6208L12.4667 5.82746C13.4133 4.82746 13.84 3.68746 12.3667 2.29413C10.9 0.914129 9.78667 1.4008 8.84 2.4008Z"
                                    stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"  stroke-linejoin="round"
                                  />
                                  <path
                                    d="M7.92667 3.36719C8.21333 5.20719 9.70667 6.61385 11.56 6.80052"
                                    stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"
                                  />
                                  <path
                                    d="M2 14.668H14" 
                                    stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"
                                  />
                                </svg>Edit
                              </a>
                          </li>
                          <li><a class="dropdown-item"   matTooltipPosition="left" matTooltip="Delete details"
                            (click)="$event.preventDefault(); $event.stopPropagation();deleteSchool(school)"
                            >
                            <svg width="16" height="16"
                                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z"
                                  fill="#F24822" />
                              </svg>Delete</a>
                            </li>
                        </ul>
                      </div>
                  </div>

                  
                </ng-container>
              </td>
              
            </tr>
          </tbody>
          </table>
        </div>
        <mat-paginator *ngIf="schoolData.length && isCurrentTab=='IndividualSchool'" [length]="totalRecords" [pageSize]="pageSize"
          [pageIndex]="pageNumber" (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100]">
        </mat-paginator>
        <div *ngIf="!schoolData.length" class="noDataFound">
          <h1>{{'No Data Found'}}</h1>
        </div>
      </ng-container>
      <ng-template #schoolUserList>
        <app-user-details [viewMode]="true" [schoolUserList]="filteredSchoolUsers" [openedFromIndividualSchool]="true" [showSchoolUser] = "showSchoolUser"
          [roles]="roles" (actionEmitter)="actionTriggered($event)" [schoolId]="schoolId"
          [clientAccountId]="clientAccountId" [packageId]="assignedPackageId">
        </app-user-details>
      </ng-template>
    </div>
    <div *ngIf="showCreateUser">
      <app-create-school (hideHeader)="hideHeader($event)" [clientAccountId]="clientAccountId" [packageToAssign]="assignedPackageId"></app-create-school>
    </div>
</section>